export default function Footer() {
  return (
    <footer className="bg-secondary text-text-dark py-8 text-center">
      <p className="text-sm font-medium">
        © 2025 <span className="text-primary font-semibold">BJD-HOME-PRO</span>{" "}
        — Artisan du détail, créateur d'espaces.
      </p>
      <p className="text-sm text-text-dark/80 mt-1">
        Chaque projet est une histoire. Merci pour votre confiance.
      </p>
    </footer>
  );
}
